import { render } from "./OrdersPage.vue?vue&type=template&id=5a718e4c&scoped=true&ts=true"
import script from "./OrdersPage.ts?vue&type=script&lang=ts"
export * from "./OrdersPage.ts?vue&type=script&lang=ts"

import "./OrdersPage.vue?vue&type=style&index=0&id=5a718e4c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a718e4c"]])

export default __exports__